export default "__VITE_ASSET__2f53c10d__"